import { useAuth } from "@clerk/clerk-react";
import { setTokenProvider } from "../api";

// Bridges Clerk's per-render getToken() into the module-level token
// provider used by api.ts. Mounted inside <ClerkLoaded> so Clerk's
// context is guaranteed to be ready when useAuth() fires.
//
// Registration happens during render (NOT in useEffect) because React
// fires effects child-first — a useEffect here would run AFTER
// AuthenticatedApp's own useEffect, meaning api.me() would fire with
// no token, 401, redirect to /welcome, loop. setTokenProvider only
// mutates a module variable (no state, no subscriptions, no
// re-renders), so calling it during render is safe and idempotent.
//
// Template "CaseThread" is the custom JWT template configured in the
// Clerk dashboard that surfaces the user's primary email as a
// top-level `email` claim — required by the Worker's clerkAuth
// middleware.
export default function ClerkTokenProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { getToken } = useAuth();
  setTokenProvider(() => getToken({ template: "CaseThread" }));
  return <>{children}</>;
}
